//var domain = "https://nutriclub.eydendigital.co.id/dtc";
//var domain = "https://dev-shop-api.daninaportal.id/v1";
var domain = "https://nutriclub.eydendigital.co.id/dtc/v2";
var accessToken = localStorage.getItem("member_access_token");
const input_member_phone = document.getElementsByName("member-phone")[0];
const btn_submit = document.getElementById("checkMemberByPhone");
const allowed_key_alpha = [8, 9, 16, 20, 32, 37, 38, 39, 40, 46];
const input_otp = document.getElementsByClassName("input-otp-form");
const btn_submit_otp = document.getElementsByClassName("btn-submit-otp")[0];
const btn_resend_otp = document.getElementsByClassName("resend-otp")[0];
var otp_is_filled = 0;
const btn_submit_register = document.getElementById("registerMember");
const input_fullname = document.getElementsByName("member-name")[0];
const input_email = document.getElementsByName("member-email")[0];
const input_email_member = document.getElementsByName(
    "member-email-existing"
)[0];
const input_child_dob = document.getElementsByName("member-child-dob")[0];
const input_member_phone_otp =
    document.getElementsByName("member_phone_otp")[0];
const action_form = document.getElementsByName("action-form")[0];
const status_register = document.getElementsByName("status-register")[0];
const status_email = document.getElementsByName("status-email")[0];
const status_consent = document.getElementsByName("status-consent")[0];
const status_member = document.getElementsByName("status-member")[0];
var form_member_consent = null;
var input_member_consent = null;
var member_consent_error = null;
var btn_member_consent = null;
const btn_email = document.getElementById("btn-email");
let typingTimer;
const typingDelay = 500;
const input_kode_referral = document.getElementsByName("member-kode-referral")[0];
const input_kode_event = document.getElementsByName("member-kode-event")[0];

const clearErrorLabel = function () {
    const error_label = document.getElementsByClassName("error");
    if (error_label.length > 0) {
        for (let i = 0; i < error_label.length; ++i) {
            error_label[i].remove();
        }
    }
};

const startTimer = (duration) => {
    var timer = duration,
        minutes,
        seconds;
    let _init = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        if (--timer < 0) {
            clearInterval(_init);
            document.querySelector(".otp-wait").style.display = "none";
            document.querySelector(".wrapper-button-resend-otp").style.display =
                "block";
            btn_resend_otp.disabled = false;
            btn_resend_otp.classList.remove("disabled");
        } else {
            document.querySelector(".otp-wait").style.display = "block";
            document.querySelector(".wrapper-button-resend-otp").style.display =
                "none";
            document.querySelector(".timer-otp").innerHTML = minutes + ":" + seconds;
            btn_resend_otp.disabled = true;
            btn_resend_otp.classList.add("disabled");
        }
    }, 1000);
};

if (btn_submit != "undefined" && btn_submit != null) {
    btn_submit.onclick = function (e) {
        e.preventDefault();
        var statusEmail = status_email.value;
        console.log("EMAIL STATUS", statusEmail);
        let phoneNumber = input_member_phone.value;
        let formattedPhoneNumber = phoneNumber.replace(/^0/, "62");
        if (statusEmail === "true") {
            console.log("ADA EMAIL");
            submitOtp(e, formattedPhoneNumber);
        } else {
            console.log("GA ADA EMAIL");
            clearErrorLabel();
            if (validation_email_member(e) > 0) {
                return false;
            }
            $.ajax({
                url: domain + "/account/membership",
                type: "GET",
                dataType: "JSON",
                data: {
                    email: input_email_member.value,
                },
                beforeSend: function () {
                    showLoader();
                },
                success: function (response) {
                    if (response.status.code === "040308") {
                        submitOtp(e, formattedPhoneNumber);
                    } else if (
                        response.status.code === "0205" ||
                        response.status.code === "0206" ||
                        response.status.code === "0207"
                    ) {
                        var messageError = "Email sudah digunakan";
                        document.querySelector("#warningLoginEmail").innerText =
                            messageError;
                        $("#warningLoginEmail").show();
                    }
                    hideLoader();
                },
                error: function (error) {
                    console.error("Error:", error);
                    hideLoader();
                },
            });
        }
    };
}

const checkMember = function (e) {
    e.preventDefault();
    clearErrorLabel();

    if (validation_phone_number(e) > 0) {
        return false;
    }

    let phoneNumber = input_member_phone.value;
    let formattedPhoneNumber = phoneNumber.replace(/^0/, "62");

    $.ajax({
        url: domain + "/account/membership",
        type: "GET",
        dataType: "JSON",
        data: {
            phone: formattedPhoneNumber,
        },
        success: function (response) {
            var form;
            var statusWelcomeMember;
            if (response.status.code == "0201" || response.status.code == "0202") {
                if (response.status.code == "0201") {
                    form = "login";
                    $("#nutrishopOtp #statusEmail").val("true");
                    localStorage.setItem("status_nutriclub", "login");
                    localStorage.setItem("status_nutrishop", "login");
                } else if (response.status.code == "0202") {
                    localStorage.setItem("status_nutriclub", "login");
                    localStorage.setItem("status_nutrishop", "registerExisting");
                    $("#nutrishopOtp #statusRegister").val("notRegisterNutrishop");
                    $("#nutrishopOtp #statusEmail").val("true");
                    form = "register";
                }
                $("#statusConsent").val(response.data.consent);
                $(".wrapper-form-email").hide();
                $(".wrapper-button-login").show();
                $(".wrapper-form-register").hide();
                statusWelcomeMember = "login";
            } else if (response.status.code == "0203") {
                localStorage.setItem("status_nutriclub", "login");
                localStorage.setItem("status_nutrishop", "registerExisting");
                $("#nutrishopOtp #statusEmail").val("false");
                $("#nutrishopOtp #statusRegister").val("notRegisterNutrishop");
                form = "register";
                $("#statusConsent").val(response.data.consent);
                $(".wrapper-form-email").show();
                $(".wrapper-button-login").show();
                $(".wrapper-form-register").hide();
                statusWelcomeMember = "login";
            } else if (response.status.code == "0204") {
                localStorage.setItem("status_nutriclub", "register");
                localStorage.setItem("status_nutrishop", "login");
                form = "register";
                $("#nutrishopOtp #statusRegister").val("notRegisterDynamia");
                $(".wrapper-form-email").hide();
                $(".wrapper-form-register").show();
                $(".wrapper-button-login").hide();
                statusWelcomeMember = "register";
            } else if (response.status.code == "040302" || response.status.code == "050121") {
                localStorage.setItem("status_nutriclub", "register");
                localStorage.setItem("status_nutrishop", "registerNew");
                form = "register";
                $("#nutrishopOtp #statusRegister").val("notRegisterBoth");
                $(".wrapper-form-email").hide();
                $(".wrapper-form-register").show();
                $(".wrapper-button-login").hide();
                statusWelcomeMember = "register";
            }
            $("#nutrishopOtp #actionForm").val(form);
            $("#nutrishopOtp #statusMember").val(statusWelcomeMember);
        },
        error: function (error) {
            console.error("Error:", error);
        },
    });
};

if (input_member_phone !== "undefined" && input_member_phone !== null) {
    if (window.screen.width < 768) {
        input_member_phone.type = "tel";
    } else {
        input_member_phone.type = "text";
    }

    input_member_phone.onkeydown = function (e) {
        let key = e.keyCode;
        console.log("input member phone on key down");
        return (key >= 48 && key <= 57) || allowed_key_alpha.indexOf(key) > -1;
    };

    input_member_phone.onkeyup = function (e) {
        console.log("input member phone on key up");
        clearTimeout(typingTimer);
        typingTimer = setTimeout(() => {
            if (validation_phone_number(e) === 0) {
                checkMember(e);
            } else {
                $(".wrapper-button-login").hide();
                $(".wrapper-form-register").hide();
                $(".wrapper-form-email").hide();
            }
        }, typingDelay);
    };

    // input_member_phone.onkeydown = function () {
    //   clearTimeout(typingTimer);
    // };
}

const validation_phone_number = function (e) {
    form_before_submit_data_error = 0;
    input_member_phone.classList.add("is-valid");
    var html = "";

    const curr_error_label = Array.from(
        input_member_phone.parentNode.getElementsByClassName("error")
    );
    curr_error_label.forEach((errorLabel) => errorLabel.remove());

    if (input_member_phone.value.replaceAll(" ", "").length <= 0) {
        input_member_phone.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Nomor ponsel (terhubung WhatsApp) wajib diisi</span>`;
        input_member_phone.parentNode.insertAdjacentHTML("beforeend", html);
    } else if (input_member_phone.value.length < 10) {
        input_member_phone.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Nomor ponsel (terhubung WhatsApp) minimal 10 karakter</span>`;
        input_member_phone.parentNode.insertAdjacentHTML("beforeend", html);
    } else if (input_member_phone.value.length > 13) {
        input_member_phone.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Nomor ponsel (terhubung WhatsApp) maksimal 13 karakter</span>`;
        input_member_phone.parentNode.insertAdjacentHTML("beforeend", html);
    }

    document.getElementById("err_count").value = form_before_submit_data_error;
    return form_before_submit_data_error;
};

const submitOtp = function (e, phone) {
    $.ajax({
        url: domain + "/account/otp",
        type: "POST",
        data: JSON.stringify({
            phone: phone,
        }),
        success: function (response) {
            if (response.status.code == 201) {
                const hiddenPhoneNumber =
                    phone.substring(0, 4) +
                    "*".repeat(phone.length - 7) +
                    phone.substring(phone.length - 3);
                console.log("nomor yang di hidden", hiddenPhoneNumber);
                $("#nutrishopOtp .modal-desc #phoneOtp").text(hiddenPhoneNumber);
                $("#nutrishopOtp #phone-otp").val(phone);
                startTimer(120);
                $("#nutrishopRegister").modal("hide");
                $("#nutrishopOtp").modal("show");
            }
        },
        error: function (error) { },
    });
};

if (input_otp.length > 0) {
    for (let i = 0; i < input_otp.length; ++i) {
        input_otp[i].onkeydown = function (e) {
            let key = e.keyCode;

            if (key === 8) {
                // Handle backspace
                this.value = "";
                otp_is_filled--;

                this.classList.remove("active");
                this.classList.remove("warning");

                if (i > 0) input_otp[i - 1].focus();
            } else {
                // Only allow numeric keys
                if ((key < 48 || key > 57) && key !== 8) e.preventDefault();
            }
        };

        input_otp[i].onkeyup = function () {
            if (this.value.length > 0) {
                this.classList.add("active");
                if (i < input_otp.length - 1) input_otp[i + 1].focus();
            } else {
                this.classList.remove("active");
            }

            // Update the filled count and validate
            updateOtpStatus();
        };
    }
}

const updateOtpStatus = function () {
    otp_is_filled = Array.from(input_otp).filter(
        (input) => input.value.trim().length > 0
    ).length;

    if (otp_is_filled === input_otp.length) {
        btn_submit_otp.disabled = false;
        btn_submit_otp.classList.remove("disabled");
        $("#warningOtp").hide();
    } else {
        btn_submit_otp.disabled = true;
        btn_submit_otp.classList.add("disabled");
        $("#warningOtp").show();
    }
};

if (btn_submit_register != "undefined" && btn_submit_register != null) {
    btn_submit_register.onclick = function (e) {
        registerMember(e);
    };
}

const registerMember = function (e) {
    e.preventDefault();
    clearErrorLabel();
    $("#warningKodeRefferalEvent").hide();

    if (validation_before_submit_data(e, "clicksubmit") > 0) {
        return false;
    }

    let phoneNumber = input_member_phone.value;
    let formattedPhoneNumber = phoneNumber.replace(/^0/, "62");
    $.ajax({
        url: domain + "/account/membership",
        type: "POST",
        data: JSON.stringify({
            phone: formattedPhoneNumber,
            name: input_fullname.value,
            email: input_email.value,
            childBirthDate: input_child_dob.value,
            // hanya salah satu: referral ATAU event
            ...(document.getElementById("toggleCode").checked
                ? { event_code: input_kode_event.value }
                : { referral_code: input_kode_referral.value }),
        }),
        beforeSend: function () {
            showLoader();
        },
        success: function (response) {
            if (response.status.code == 200) {
                let position = "Website";
                if (input_kode_referral.value) {
                    position = "Kode Referral";
                } else if (input_kode_event.value) {
                    position = "Kode Event";
                }
                const ageInMonths = getAgeInMonths(input_child_dob.value);
                const bopOrGum = ageInMonths < 12 ? "BOP" : "GUM";
                dataLayer.push({
                    'event': 'interaction',
                    'event_name': 'input_registration_nutrishop',
                    'marketing_optin': 'no',
                    'position': position,// Kode Referral or Kode Event or Website (for no input code)
                    'status': bopOrGum, // GUM or BOP
                });
                submitOtp(e, formattedPhoneNumber);
            } else if (response.status.code == 22) {
                var messageError = "Email sudah digunakan";
                document.querySelector("#warningRegister").innerText = messageError;
                $("#warningRegister").show();
            } else if (["040306", "050142", "050144"].includes(String(response.status.code))) {
                // pesan error diambil langsung dari server
                document.querySelector("#warningKodeRefferalEvent").innerText =
                    response.status.message.id;
                $("#warningKodeRefferalEvent").show();
            } else if (response.status.success === false) {
                // kode error lain yang belum ditangani: tetap tampilkan pesan server
                document.querySelector("#warningRegister").innerText =
                    response.status.message.id;
                $("#warningRegister").show();
            }
            hideLoader();
        },
        error: function (error) {
            console.error("Error:", error);
            hideLoader();
        },
    });
};

const validation_before_submit_data = function (e, triggerfrom) {
    form_before_submit_data_error = 0;

    validation_fullname(e);
    validation_email(e);
    validation_child_dob(e);

    document.getElementById("err_count").value = form_before_submit_data_error;
    return form_before_submit_data_error;
};

const validation_fullname = function (e) {
    input_fullname.classList.add("is-valid");
    var html = "";
    const curr_error_label =
        input_fullname.parentNode.getElementsByClassName("error");

    var re = /^[A-Za-z]+$/;

    if (curr_error_label.length > 0) {
        for (let i = 0; i < curr_error_label.length; ++i) {
            curr_error_label[i].remove();
        }
    }

    if (input_fullname.value.replaceAll(" ", "").length <= 0) {
        input_fullname.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Nama lengkap harus diisi</span>`;
        input_fullname.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }

    if (
        !re.test(document.getElementById("nameMember").value.replaceAll(" ", ""))
    ) {
        input_fullname.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Nama lengkap hanya bisa diinput huruf</span>`;
        input_fullname.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }

    if (input_fullname.value.length < 3) {
        input_fullname.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Nama lengkap minimal 3 karakter</span>`;
        input_fullname.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }

    if (input_fullname.value.length > 40) {
        input_fullname.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Nama lengkap maksimal 40 karakter</span>`;
        input_fullname.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }
};

if (input_fullname != "undefined" && input_fullname != null) {
    input_fullname.onkeydown = function (e) {
        let key = e.keyCode;
        return (key >= 65 && key <= 90) || allowed_key_alpha.indexOf(key) > -1;
    };
    input_fullname.onkeyup = function (e) {
        validation_before_submit_data(e, "inputchange");
    };
}

const validation_email = function (e) {
    $("#warningRegister").hide();
    input_email.classList.add("is-valid");
    let html = "";
    const curr_error_label =
        input_email.parentNode.getElementsByClassName("error");

    if (curr_error_label.length > 0) {
        for (let i = 0; i < curr_error_label.length; ++i) {
            curr_error_label[i].remove();
        }
    }

    if (input_email.value.replaceAll(" ", "").length <= 0) {
        input_email.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Email harus diisi</span>`;
        input_email.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }

    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!re.test(input_email.value)) {
        input_email.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Format Email Tidak Valid</span>`;
        input_email.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }

    const atIndex = input_email.value.indexOf("@");
    if (atIndex !== -1 && input_email.value[atIndex + 1] === ".") {
        input_email.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Email tidak boleh memiliki '.' setelah '@'</span>`;
        input_email.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }
    if (atIndex > 0 && input_email.value[atIndex - 1] === ".") {
        input_email.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Email tidak boleh memiliki '.' sebelum '@'</span>`;
        input_email.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }
};

const validation_email_member = function (e) {
    $("#warningLoginEmail").hide();
    input_email_member.classList.add("is-valid");
    let html = "";
    const curr_error_label =
        input_email_member.parentNode.getElementsByClassName("error");

    if (curr_error_label.length > 0) {
        for (let i = 0; i < curr_error_label.length; ++i) {
            curr_error_label[i].remove();
        }
    }

    if (input_email_member.value.replaceAll(" ", "").length <= 0) {
        input_email_member.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Email harus diisi</span>`;
        input_email_member.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }

    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!re.test(input_email_member.value)) {
        input_email_member.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Format Email Tidak Valid</span>`;
        input_email_member.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }

    const atIndex = input_email_member.value.indexOf("@");
    if (atIndex !== -1 && input_email_member.value[atIndex + 1] === ".") {
        input_email_member.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Email tidak boleh memiliki '.' setelah '@'</span>`;
        input_email_member.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }
    if (atIndex > 0 && input_email_member.value[atIndex - 1] === ".") {
        input_email_member.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Email tidak boleh memiliki '.' sebelum '@'</span>`;
        input_email_member.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }
};

if (input_email_member != "undefined" && input_email != null) {
    input_email_member.onkeyup = function (e) {
        let key = e.keyCode;
        if (key == 32) {
            return false;
        } else {
            validation_email_member(e, "inputchange");
        }
    };
    input_email_member.onkeydown = function (e) {
        let key = e.keyCode;
        if (key == 32) {
            return false;
        }
    };
}

if (input_email != "undefined" && input_email != null) {
    input_email.onkeyup = function (e) {
        let key = e.keyCode;
        if (key == 32) {
            return false;
        } else {
            validation_before_submit_data(e, "inputchange");
        }
    };
    input_email.onkeydown = function (e) {
        let key = e.keyCode;
        if (key == 32) {
            return false;
        }
    };
}

const validation_child_dob = function (e) {
    input_child_dob.classList.add("is-valid");
    var html = "";

    document.querySelectorAll('.small-info').forEach(el => {
        el.style.display = 'contents';
    });

    const curr_error_label =
        input_child_dob.parentNode.getElementsByClassName("error");
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const day = currentDate.getDate().toString().padStart(2, "0");
    const today_date = `${year}-${month}-${day}`;

    if (curr_error_label.length > 0) {
        for (let i = 0; i < curr_error_label.length; ++i) {
            curr_error_label[i].remove();
        }
    }

    if (input_child_dob.value.replaceAll(" ", "").length <= 0) {
        input_child_dob.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Tanggal lahir anak wajib diisi</span>`;
        input_child_dob.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }

    let array_children_dob = input_child_dob.value.split("-");
    let array_date_today = today_date.split("-");

    let comparedob =
        array_children_dob[0] + array_children_dob[1] + array_children_dob[2];
    let comparedatetoday =
        array_date_today[0] + array_date_today[1] + array_date_today[2];

    console.log("TGL LAHIR", input_child_dob.value);
    if (
        array_children_dob[0].length !== 4 &&
        array_children_dob[1].length !== 2 &&
        array_children_dob[2].length !== 2
    ) {
        input_child_dob.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Format tanggal lahir anak harus dd/mm/yyyy</span>`;
        input_child_dob.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }

    if (parseInt(array_children_dob[2]) > 31) {
        input_child_dob.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Tanggal pada tanggal lahir anak tidak valid</span>`;
        input_child_dob.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }

    if (parseInt(array_children_dob[1]) > 12) {
        input_child_dob.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Bulan pada tanggal lahir anak tidak valid</span>`;
        input_child_dob.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }
    if (comparedob > comparedatetoday) {
        input_child_dob.classList.remove("is-valid");
        form_before_submit_data_error++;
        html = `<span class="error">Tanggal lahir anak tidak boleh melebihi tanggal hari ini</span>`;
        input_child_dob.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }
    let dob = new Date(array_children_dob[0], array_children_dob[1] - 1, array_children_dob[2]);
    let today = new Date();
    let twelveYearsAgo = new Date(today.getFullYear() - 7, today.getMonth(), today.getDate());
    console.log("DOB", dob);
    console.log("17 YEARS AGO", twelveYearsAgo);

    if (dob < twelveYearsAgo) {
        input_child_dob.classList.remove("is-valid");
        form_before_submit_data_error++;
        document.querySelectorAll('.small-info').forEach(el => {
            el.style.display = 'none';
        });
        html = `<span class="error">Usia si Kecil Maksimal 7 Tahun</span>`;
        input_child_dob.parentNode.insertAdjacentHTML("beforeend", html);
        return;
    }
};

if (input_child_dob != "undefined" && input_child_dob != null) {
    input_child_dob.onchange = function (e) {
        validation_before_submit_data(e, "inputchange");
    };
}

if (btn_submit_otp != "undefined" && btn_submit_otp != null) {
    btn_submit_otp.onclick = function (e) {
        e.preventDefault();

        let otp = [];
        for (let i = 0; i < input_otp.length; ++i) {
            otp.push(input_otp[i].value);
        }
        var currentUrl = window.location.href;
        $.ajax({
            url: domain + "/account/otp/verify",
            type: "POST",
            data: JSON.stringify({
                phone: input_member_phone_otp.value,
                otp: otp.join(""),
                event: action_form.value,
                redirectTo: currentUrl,
                email: input_email_member.value,
            }),
            beforeSend: function () {
                showLoader();
            },
            success: function (response) {
                console.log("RESPONSE", response);
                if (response.status.code == 200) {
                    setCookie("nutrishopMemberId", response.data.membershipId, 1);
                    localStorage.setItem(
                        "member_consent_redirect",
                        response.data.redirectUrl
                    );
                    localStorage.setItem(
                        "member_access_token",
                        response.data.customerAccessToken
                    );
                    var statusNutriclub = localStorage.getItem("status_nutriclub");
                    var statusNutrishop = localStorage.getItem("status_nutrishop");

                    smartech('contact', '1', {
                        'pk^member_id': response.data.membershipId,
                        'email': input_email_member.value,
                        'mobile': input_member_phone_otp.value,
                        'FIRST_NAME': input_fullname.value,
                    });
                    smartech('identify', response.data.membershipId);
                    let position = "Website";
                    if (input_kode_referral.value) {
                        position = "Kode Referral";
                    } else if (input_kode_event.value) {
                        position = "Kode Event";
                    }
                    const ageInMonths = getAgeInMonths(input_child_dob.value);
                    const bopOrGum = ageInMonths < 12 ? "BOP" : "GUM";
                    if (statusNutriclub === "register") {
                        dataLayer.push({
                            event: "Nutriclub_Success_Register_PopUp",
                            step: "Success Regiscter",
                            LastPageVisited: "Nutrishop",
                            method: "Website",
                        });
                        smartech('dispatch', 'Register', {
                            'email': input_email_member.value,
                            'mobile': input_member_phone_otp.value,
                            'FIRST_NAME': input_fullname.value,
                        });
                    } else {
                        dataLayer.push({
                            event: "login",
                            step: "Success Login",
                            LastPageVisited: "Nutrishop",
                            method: "without password",
                        });
                    }
                    if (statusNutrishop === "registerExisting") {
                        dataLayer.push({
                            event: "interaction",
                            event_name: "registration_nutrishop",
                            method: "existing user",
                            marketing_optin: "no",
                            status: bopOrGum,
                            position: position,
                        });
                        smartech('dispatch', 'registration_nutrishop', {
                            'method': "existing user",
                            'marketing_optin': "no",
                            'status': "success",
                        });
                        smartech('dispatch', 'Register', {
                            'email': input_email_member.value,
                            'mobile': input_member_phone_otp.value,
                            'FIRST_NAME': input_fullname.value,
                        });
                    } else if (statusNutrishop === "registerNew") {
                        dataLayer.push({
                            event: "interaction",
                            event_name: "registration_nutrishop",
                            method: "new user",
                            marketing_optin: "no",
                            status: bopOrGum,
                            position: position,
                        });
                        smartech('dispatch', 'registration_nutrishop', {
                            'method': "new user",
                            'marketing_optin': "no",
                            'status': "success",
                        });
                        smartech('dispatch', 'Register', {
                            'email': input_email_member.value,
                            'mobile': input_member_phone_otp.value,
                            'FIRST_NAME': input_fullname.value,
                        });
                    } else {
                        dataLayer.push({
                            event: "interaction",
                            event_name: "login_nutrishop",
                            method: "Input Number",
                            status: "success",
                        });
                        smartech('dispatch', 'login_nutrishop', {
                            'method': "Input Number",
                            'status': "success",
                        });
                    }
                    localStorage.setItem("status_user", status_member.value);
                    var statusConsent = status_consent.value;
                    if (action_form.value == "register") {
                        if (
                            status_register.value === "notRegisterDynamia" ||
                            status_register.value === "notRegisterBoth"
                        ) {
                            updateMemberConsent(e);
                        } else {
                            if (statusConsent === "true") {
                                window.location.href = response.data.redirectUrl;
                            } else {
                                $("#nutrishopOtp").modal("hide");
                                $("#nutrishopConsent").modal("show");
                            }
                        }
                    } else {
                        if (statusConsent === "true") {
                            window.location.href = response.data.redirectUrl;
                        } else {
                            $("#nutrishopOtp").modal("hide");
                            $("#nutrishopConsent").modal("show");
                        }
                    }
                } else if (
                    response.status.code == "040329" ||
                    response.status.code == "22"
                ) {
                    $("#nutrishopOtp").modal("hide");
                    $("#nutrishopEmail").modal("show");
                } else {
                    var messageError;
                    if (response.status.code == 401) {
                        messageError = "Kode OTP yang Mama masukkan sudah expired";
                    } else if (response.status.code == 404) {
                        messageError = "Kode OTP yang Mama masukkan salah";
                    } else {
                        messageError = "Silakan Periksa Form Data Mama";
                    }
                    document.querySelector("#warningOtp").innerText = messageError;
                    $("#warningOtp").show();
                    $(".input-otp-form").addClass("warning");
                    btn_submit_otp.classList.add("disabled");
                    btn_submit_otp.disabled = true;
                    // $("#nutrishopFailed").modal("show");
                }
                hideLoader();
            },
            error: function (error) {
                console.log("ERROR", error);
                hideLoader();
            },
        });
    };
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

if (btn_resend_otp != "undefined" && btn_resend_otp != null) {
    btn_resend_otp.onclick = function (e) {
        e.preventDefault();
        startTimer(120);
        $.ajax({
            url: domain + "/account/otp",
            type: "POST",
            data: JSON.stringify({
                phone: input_member_phone_otp.value,
            }),
            beforeSend: function () {
                showLoader();
            },
            success: function (response) {
                if (response.status.code == 201) {
                    console.log("KESINI KOK");
                    var messageError = "Kode OTP Berhasil Terkirim";
                    document.querySelector("#warningOtp").innerText = messageError;
                    $("#warningOtp").show();
                    // $("#nutrishopSuccess").modal("show");
                } else {
                    var messageError = "Kode OTP Gagal Terkirim";
                    document.querySelector("#warningOtp").innerText = messageError;
                    $("#warningOtp").show();
                    // $("#nutrishopFailed").modal("show");
                }
                btn_submit_otp.classList.add("disabled");
                btn_submit_otp.disabled = true;
                resetOtpForm();
                hideLoader();
            },
            error: function (error) {
                console.log("Resend Gagal!");
                hideLoader();
            },
        });
    };
}

const resetOtpForm = function () {
    for (let i = 0; i < input_otp.length; ++i) {
        input_otp[i].value = "";
    }

    input_otp[0].focus();
    $(".input-otp-form").removeClass("warning");
    document.querySelector(".otp-wait").style.display = "block";
    otp_is_filled = 0;
};

const updateMemberConsent = function (e) {
    e.preventDefault();

    $.ajax({
        url: domain + "/account/membership/consent",
        type: "POST",
        data: JSON.stringify({
            phone: input_member_phone_otp.value,
            consent: true,
        }),
        beforeSend: function () {
            showLoader();
        },
        success: function (response) {
            console.log(response);
            const redirect = localStorage.getItem("member_consent_redirect");
            if (response.status.code == 200) {
                window.location.href = redirect;
            }
            hideLoader();
        },
        error: function (error) {
            console.log(error);
            hideLoader();
        },
    });
};

const initFormMemberConsent = function () {
    form_member_consent = document.getElementsByClassName(
        "form-member-consent"
    )[0];
    input_member_consent = document.getElementById("member_consent");
    member_consent_error = document
        .getElementById("member_consent_error_wrapper")
        .getElementsByClassName("error-label")[0];
    btn_member_consent = document.getElementById("btn_member_consent");

    if (input_member_consent != "undefined" && input_member_consent != null) {
        input_member_consent.onchange = function () {
            if (input_member_consent.checked) {
                btn_member_consent.disabled = false;
                return;
            }

            btn_member_consent.disabled = true;
        };
    }

    if (btn_member_consent != "undefined" && btn_member_consent != null) {
        btn_member_consent.onclick = function (e) {
            e.preventDefault();

            updateMemberConsent(e);
            input_member_consent.checked = false;
            member_consent_error.parentNode.classList.add("hidden");
            btn_member_consent.disabled = true;
        };
    }
};

$(function () {
    initFormMemberConsent();
    console.log("input_member_phone", input_member_phone);
    // console.log(input_member_phone);
});

$(document).ready(function () {
    var statusLogin = localStorage.getItem("status_user");
    const urlParams = new URLSearchParams(window.location.search);
    const statusLoginParam = urlParams.get("mid");
    console.log("STATUS LOGIN", statusLogin);
    if (
        statusLogin === "login" ||
        statusLogin === "register" ||
        statusLoginParam != null
    ) {
        var messageError;
        if (statusLogin === "login" || statusLoginParam != null) {
            messageError = "Mama sudah berhasil Masuk di Nutrishop!";
        } else {
            messageError = "Selamat, Mama sudah berhasil Terdaftar di Nutrishop!";
        }
        document.querySelector("#nutriclubSuccessTitle").innerText = messageError;
        $("#nutriclubSuccessLogin").modal("show");
        if (window.customerTags && window.customerTags.includes("BOT_TRADER")) {
            if (getCookie("cart") != '') {
                document.cookie = 'cart=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                window.location.reload();
            }
        }
    }
    $("#redirectNutriclub img").on("click", function (event) {
        event.preventDefault();
        ssoNutriclub();
    });
    localStorage.removeItem("status_nutrishop");
    localStorage.removeItem("status_nutriclub");
});

const ssoNutriclub = function (redirectTo) {
    if (accessToken === null) {
        showPopupRegister();
    }
    var urlSso;
    if (redirectTo) {
        urlSso = redirectTo;
    } else {
        urlSso = "https://nutriclub.eydendigital.co.id/membership/dashboard";
        //urlSso = "https://dev1.nutriclub.co.id/membership/dashboard";
    }
    $.ajax({
        url: domain + "/account/nutriclub/sso",
        type: "POST",
        dataType: "JSON",
        data: JSON.stringify({
            cat: accessToken,
            redirectTo: urlSso,
        }),
        beforeSend: function () {
            showLoader();
        },
        success: function (response) {
            if (response && response.status.code == "200") {
                window.location.href = response.data.redirectUrl;
            } else {
                console.error("Invalid API response:", response);
            }
            hideLoader();
        },
        error: function (xhr, status, error) {
            console.error("Error fetching dynamic URL:", status, error);
            hideLoader();
        },
    });
};

function showLoader() {
    $("#overlay-loader").removeClass("d-none");
}

function hideLoader() {
    $("#overlay-loader").addClass("d-none");
}

function closeSuccessLoginNew() {
    localStorage.removeItem("status_user");
    const url = new URL(window.location.href);
    const params = url.searchParams;

    if (params.has("mid")) {
        params.delete("mid");
        history.replaceState(null, "", url.pathname + "?" + params.toString());
    }
}

if (btn_email != "undefined" && btn_email != null) {
    btn_email.onclick = function (e) {
        e.preventDefault();
        $("#nutrishopEmail").modal("hide");
        $("#nutrishopOtp").modal("nutrishopRegister");
    };
}

function clearAllInputs() {
    $(".nutrishop-register-login input").each(function () {
        $(this).val("");
        $(this).removeClass("is-valid");
    });
    $("#nutrishopOtp input").each(function () {
        $(this).val("");
        $(this).removeClass("is-valid");
    });
    $("#nutrishopConsent input").each(function () {
        $(this).val("");
        $(this).removeClass("is-valid");
    });
}
function showPopupRegister() {
    $("#nutrishopRegister").modal("show");
    $(".wrapper-form-register").hide();
    $(".wrapper-button-login").hide();
    $(".wrapper-form-email").hide();
    clearAllInputs();
}

document.addEventListener('DOMContentLoaded', function () {
    const cartIcon = document.querySelector('.header-cart .js-header-cart');

    if (cartIcon) {
        cartIcon.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            if (typeof smartech !== "undefined") {
                smartech('dispatch', 'click_cart', {
                    position: window.location.href
                });
            }

            setTimeout(function () {
                window.location.href = cartIcon.getAttribute('href');
            }, 200);
        });
    }

    const checkChatIcon = setInterval(() => {
        const chatIcon = document.getElementById('chatway_widget_trigger');
        if (chatIcon) {
            clearInterval(checkChatIcon);

            chatIcon.addEventListener('click', function (e) {
                if (typeof smartech !== "undefined") {
                    smartech('dispatch', 'chat_nutrishop', {
                        position: window.location.href
                    });
                }
            });
        }
    }, 500);

    document.querySelectorAll('.main-menu__nav > .main-menu__nav-item > a.main-menu__link')
        .forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();

                var menuName = link.innerText.trim();
                var targetUrl = link.getAttribute('href');

                if (typeof smartech !== "undefined") {
                    smartech('dispatch', 'click_menu_header_nutrishop', {
                        button_name: menuName
                    });
                }
                setTimeout(function () {
                    window.location.href = targetUrl;
                }, 300);
            });
        });
    document.querySelectorAll('.menu-drawer__menu-item.list-menu__item[href],.menu-drawer__menu > li > details > summary a')
        .forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();

                var menuName = link.innerText.trim();
                var targetUrl = link.getAttribute('href');

                if (typeof smartech !== "undefined") {
                    smartech('dispatch', 'click_menu_nutrishop', {
                        button_name: menuName
                    });
                }
                setTimeout(function () {
                    window.location.href = targetUrl;
                }, 300);
            });
        });
});

const dobInput = document.getElementById('childDobMember');
const today = new Date();
const yyyy = today.getFullYear();
const mm = String(today.getMonth() + 1).padStart(2, '0');
const dd = String(today.getDate()).padStart(2, '0');
const formattedToday = `${yyyy}-${mm}-${dd}`;
const twelveYearsAgo = new Date(today.getFullYear() - 7, today.getMonth(), today.getDate());
const formattedMin = `${twelveYearsAgo.getFullYear()}-${String(twelveYearsAgo.getMonth() + 1).padStart(2, '0')}-${String(twelveYearsAgo.getDate()).padStart(2, '0')}`;
dobInput.setAttribute('max', formattedToday);
dobInput.setAttribute('min', formattedMin);

const toggle = document.getElementById('toggleCode');
const referral = document.getElementById('inputReferral');
const eventInput = document.getElementById('inputEvent');

const labelRef = document.getElementById('label-ref');
const labelEvent = document.getElementById('label-event');

toggle.addEventListener('change', () => {
    // kosongkan input yang disembunyikan & warning lama
    (toggle.checked ? referral : eventInput).value = '';
    $('#warningKodeRefferalEvent').hide().text('');
    if (toggle.checked) {
        referral.classList.add('hidden');
        eventInput.classList.remove('hidden');

        labelRef.classList.remove('active');
        labelEvent.classList.add('active');
    } else {
        eventInput.classList.add('hidden');
        referral.classList.remove('hidden');

        labelEvent.classList.remove('active');
        labelRef.classList.add('active');
    }
});

function getAgeInMonths(birthDate) {
    const today = new Date();
    const dob = new Date(birthDate);

    let months =
        (today.getFullYear() - dob.getFullYear()) * 12 +
        (today.getMonth() - dob.getMonth());

    // kalau tanggal hari ini < tanggal lahir, kurangi 1 bulan
    if (today.getDate() < dob.getDate()) {
        months--;
    }

    return months;
}
